import React, { useState } from 'react';
import clsx from 'clsx';
import {
  makeStyles,
  useTheme,
  Theme,
  createStyles,
  withStyles,
} from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import useStyles from '../styles';
import { useSidebarIsVisible } from '../../../../redux/reducers/gl_navigation_reducer/selectors';
import NavigationActions from '../../../../redux/reducers/gl_navigation_reducer/actions';
import LanguageMenu from '../../../../components/app_common/LanguageSelector';
import LanguageIcon from '@material-ui/icons/Language';
import {
  Badge,
  InputBase,
  ListItemIcon,
  Menu,
  AppBarProps,
  Button,
  Box,
  MenuProps,
  Hidden,
  Chip,
  Avatar,
  colors,
  useMediaQuery,
  TextField,
  Paper,
  Dialog,
} from '@material-ui/core';
import { matchPath, useHistory, useLocation } from 'react-router';
import SelectButton from 'components/molecules/SelectButton';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import * as NavigationSelectors from 'redux/reducers/gl_navigation_reducer/selectors';
import { getNavbarConfig } from 'navigation/config/Routes';
import * as Paths from 'utils/path';
import Configuration, { TranslationKey } from '../configuration';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/SearchRounded';
import { NavbarTypeEnum } from 'constants/navigation';
import { withPermissions } from '../../../../middlewares';
import {
  NotificationButton,
  ProfileButton,
  SearchButton,
  ConversationButton,
  RegisterLoginButton,
  FavoritesButton,
  SavedSearches,
  Logo,
} from '../Actions';
import store from 'redux/store';
import PermissionsEnum from 'constants/permissions';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import useHomePage from 'hooks/useHomePage';
import { useHostDetails } from 'redux/reducers/gl_host_provider/selectors';
import { IStoreUrlOutput } from 'services/api/store';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { CancelIcon, LocationIcon } from './icons';
import useDebounce from 'hooks/useDebounce';
import ProductActions from 'scenes/Products_page/store/actions';
import * as ProductSelectors from 'scenes/Products_page/store/selectors';
import { IFetchGoogleSearchPlaceOutput } from 'services/api/google';
import _ from 'lodash';
import useProductListPage from 'hooks/useProductListPage';
import useMobile from 'hooks/useMobile';
import { useLogin } from 'redux/reducers/gl_auth_reducer/selectors';
import {
  APP_COLOR_PRIMARY,
  APP_COLOR_SECONDARY,
  TEXT_COLOR_HIGHLIGHT,
  TEXT_COLOR_PRIMARY,
  TEXT_COLOR_SECONDARY,
} from 'styles/colors';
import NavigationConfig from 'navigation/config';
import { GamePopup } from 'scenes/GameScene_page/GamePopup';
const menuLanId = 'primary-lan-account-menu';
// const menuId = 'primary-search-account-menu';
// const mobileMenuId = 'primary-search-account-menu-mobile';

export function SearchTextField(props: {
  setIsSearchMobile?: (isSearchMobile: boolean) => void;
  isSearchMobile?: boolean;
  style?: any;
  setPlaces?: (places: IFetchGoogleSearchPlaceOutput[]) => void;
}) {
  const dispatch = useDispatch();
  const classes = useStyles({});
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm: string = useDebounce<string>(searchTerm, 1500);

  React.useEffect(
    () => {
      if (debouncedSearchTerm !== '') {
        dispatch(
          ProductActions.fetchGoogleSearchPlace({
            keyword: debouncedSearchTerm,
          })
        );

        // onSearchPlace(debouncedSearchTerm);
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  return (
    <Paper component="form" className={classes.searchRoot} style={props.style}>
      <SearchIcon />
      <InputBase
        className={classes.searchInput}
        autoFocus={props.isSearchMobile ? true : false}
        placeholder="Search Google Maps"
        inputProps={{ 'aria-label': 'search google maps' }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onClick={() => {
          console.log('here');
          props.setIsSearchMobile && props.setIsSearchMobile(true);
          props.setPlaces && props.setPlaces([]);
        }}
      />
      {searchTerm !== '' ? (
        <IconButton onClick={() => setSearchTerm('')}>
          <CancelIcon />
        </IconButton>
      ) : null}
    </Paper>
  );
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function SearchModal(props: {
  setIsSearchMobile: (isSearchMobile: boolean) => void;
  isSearchMobile: boolean;
}) {
  const dispatch = useDispatch();
  const googleSearchPlace = ProductSelectors.useGetGoogleSearchPlace();
  const [places, setPlaces] = useState<IFetchGoogleSearchPlaceOutput[]>([]);
  React.useEffect(() => {
    if (googleSearchPlace?.data) {
      setPlaces(googleSearchPlace?.data);
    }
  }, [googleSearchPlace]);

  return (
    <Dialog
      fullScreen
      open={props.isSearchMobile}
      onClose={() => props.setIsSearchMobile(false)}
      TransitionComponent={Transition}
    >
      <Paper
        style={{
          padding: '20px 25px',
          height: '100%',
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="27px"
        >
          <SearchTextField
            isSearchMobile={props.isSearchMobile}
            setPlaces={setPlaces}
            style={props.isSearchMobile ? { width: 258 } : { width: 200 }}
          />
          <Button
            variant="text"
            style={{ textTransform: 'none' }}
            children="Cancel"
            onClick={() => props.setIsSearchMobile(false)}
          />
        </Box>
        {places.map((place) => {
          return (
            <Box
              onClick={() => {
                const map = _.get(window, 'map', null);

                props.setIsSearchMobile(false);
                const latlng: [number, number] = [
                  place.geometry.location.lat as number,
                  place.geometry.location.lng as number,
                ];
                dispatch(
                  ProductActions.setPointSelect({
                    lat: latlng[0],
                    lng: latlng[1],
                  })
                );
                map && map.flyTo(latlng);
              }}
              display="flex"
              alignItems="center"
            >
              <LocationIcon />
              <Box marginLeft="15px">
                <Typography>{place.name}</Typography>
                <Typography style={{ color: '#8C949E' }}>
                  {place.formatted_address}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Paper>
    </Dialog>
  );
}

const AppbarMenu = (props: any) => {
  console.log('Render AppbarMenu');
  // const hostDetails = useHostDetails();
  // const hostSettings = hostDetails?.data?.settings;

  const classes = useStyles({});
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const host = useHostDetails();
  const isLoggedin = useLogin();
  const [lanAnchorEl, setLanAnchorEl] = React.useState<null | HTMLElement>(
    null
  );
  const [openGamePopup, setOpenGamePopup] = useState(false);

  const isLanMenuOpen = Boolean(lanAnchorEl);
  const navbarType = NavigationSelectors.useNavigationType();
  const isMobile = useMobile();
  const [isSearchMobile, setIsSearchMobile] = useState(false);

  const handleLanguageMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setLanAnchorEl(event.currentTarget);
  };
  const isHomePage = useHomePage();
  const isProductListPage = useProductListPage();

  const handleLanMenuClose = () => {
    setLanAnchorEl(null);
  };

  const renderLanguageMenu = (
    <LanguageMenu
      handleLanMenuClose={handleLanMenuClose}
      isLanMenuOpen={isLanMenuOpen}
      menuLanId={menuLanId}
      lanAnchorEl={lanAnchorEl}
    />
  );

  const ButtonsGroupWrapper = React.useMemo(() => <ButtonsGroup />, []);

  const AppbarMenu = (
    <AppBar
      position="fixed"
      elevation={0}
      // className={clsx(classes.appBar)}
      style={{
        // boxShadow: '0.2px 0.2px 0.2px 0.2px',
        backgroundColor: 'transparent',
        color: TEXT_COLOR_HIGHLIGHT({
          darkMode: theme.palette.type === 'dark',
          transparency: 1,
        }),
        overflowX: 'auto',
      }}
    >
      <Toolbar>
        <OpenSideBarIconButton />
        {/* <div className={classes.navIcon}>
          <Logo />
        </div> */}

        {isLoggedin && location.pathname != '/game' && (
          <Button
            variant={'contained'}
            style={{
              marginLeft: '1em',
              backgroundColor: APP_COLOR_SECONDARY({
                darkMode: theme.palette.type === 'dark',
                transparency: 1,
              }),
              color: 'white',
            }}
            onClick={() =>
              history.push(NavigationConfig.clientAccountProfilePage().path)
            }
          >
            Profile Details / Change Avatar
          </Button>
        )}
        {!isMobile && isLoggedin && location.pathname != '/game' && (
          <>
            <GamePopup
              open={openGamePopup}
              onClose={() => setOpenGamePopup(false)}
            />
            <Button
              variant={'contained'}
              style={{
                marginLeft: '1em',
                backgroundColor: APP_COLOR_SECONDARY({
                  darkMode: theme.palette.type === 'dark',
                  transparency: 1,
                }),
                color: 'white',
              }}
              onClick={() => setOpenGamePopup(true)}
            >
              3D Mall
            </Button>
          </>
        )}

        <div className={classes.grow}>
          {navbarType === NavbarTypeEnum.TOP_MENU && ButtonsGroupWrapper}
        </div>
        <div
          style={{
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {/* <BoltButton /> */}
          {/* <DateButton /> */}

          {/* <div className={classes.navIcon}>
            <SearchButton />
          </div> */}
          {/* <NotificationButton /> */}

          {/* {host?.data?.settings['cellock.general.shop'] === '1' && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
              className={classes.navIcon}
            >
              <>
                <FavoritesButton />
                <SavedSearches />
              </>
            </div>
          )} */}

          {/* {Number(hostSettings?.['cellock.general.blog']) ? (
            <BlogsButton />
          ) : null}
          {Number(hostSettings?.['cellock.general.news']) ? (
            <NewsButton />
          ) : null} */}

          <Button
            aria-controls={menuLanId}
            color="inherit"
            // className={clsx(classes.navbarElementSpacing)}
            onClick={handleLanguageMenuOpen}
            style={{
              marginLeft: '0.5em',
              marginRight: '0.5em',
              backgroundColor: APP_COLOR_SECONDARY({
                darkMode: theme.palette.type === 'dark',
                transparency: 1,
              }),
              color: 'white',
            }}
          >
            <LanguageIcon />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
              className={classes.navIcon}
            >
              <ExpandMoreIcon />
            </div>
          </Button>

          <div
            className={classes.navIcon}
            style={{
              backgroundColor: APP_COLOR_SECONDARY({
                darkMode: theme.palette.type === 'dark',
                transparency: 1,
              }),
              color: 'white',
              borderRadius: '4px',
            }}
          >
            <ConversationButton />
          </div>

          <RegisterLoginButton />
          <ProfileButton />
        </div>
      </Toolbar>
      {renderLanguageMenu}
    </AppBar>
  );

  const AppbarMobile = (
    <AppBar
      position="fixed"
      color={isHomePage ? 'transparent' : ('default' as any)}
      elevation={0}
      className={clsx(classes.appBar)}
      style={{
        // boxShadow: '0.2px 0.2px 0.2px 0.2px',
        backgroundColor: 'transparent',
        // color: isHomePage ? 'white' : theme.palette.primary.main,
        overflowX: 'auto',
      }}
    >
      <Toolbar
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: 'white',
        }}
      >
        <OpenSideBarIconButton />

        {!isProductListPage ? (
          <div className={classes.navIcon}>
            <Logo />
          </div>
        ) : (
          <SearchTextField
            style={isSearchMobile ? { width: 258 } : { width: 200 }}
            setIsSearchMobile={setIsSearchMobile}
          />
        )}
        <SearchModal
          isSearchMobile={isSearchMobile}
          setIsSearchMobile={setIsSearchMobile}
        />

        <div
          style={{
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <RegisterLoginButton />
          <ProfileButton />
        </div>
      </Toolbar>
      {renderLanguageMenu}
    </AppBar>
  );

  return (
    <>
      {isHomePage ? (
        <ElevationScroll
          propsOnScroll={
            {
              className: clsx(classes.appBar),
              // color: 'default' as any,
              style: {
                backgroundColor: 'transparent',
                // backgroundColor: APP_COLOR_PRIMARY({
                //   darkMode: theme.palette.type === 'dark',
                //   transparency: 1,
                // }),
                // color: TEXT_COLOR_PRIMARY({
                //   darkMode: theme.palette.type === 'dark',
                //   transparency: 1,
                // }),
                // color: theme.palette.secondary.main,
                overflowX: 'auto',
              },
            } as AppBarProps
          }
        >
          {AppbarMenu}
        </ElevationScroll>
      ) : isMobile ? (
        AppbarMobile
      ) : (
        AppbarMenu
      )}
    </>
  );
};

/**
 * Mobile Devices: Visible always
 * Desktop: Visible only when sidebar is enable
 *
 */
const OpenSideBarIconButton = React.memo(() => {
  const classes = useStyles({});
  const dispatch = useDispatch();
  const navbarType = NavigationSelectors.useNavigationType();

  const ButtonIcon = React.useMemo(
    () => (
      <IconButton
        aria-label="open drawer"
        color="inherit"
        onClick={() => {
          // dispatch(
          //   NavigationActions.setSideMenuVisiblityAction(
          //     !NavigationSelectors.sideBarIsVisible()
          //   )
          // );
          dispatch(
            NavigationActions.showUserMenuAction({
              visible: !store.getState().NavigationReducer.userMenuIsOpen,
            })
          );
        }}
        edge="start"
        className={clsx(classes.menuButton)}
      >
        <MenuIcon />
      </IconButton>
    ),
    [classes]
  );

  return (
    <React.Fragment>
      {/* visible in desktop */}
      {/* {Configuration.sidebar.enable && <Hidden smDown>{ButtonIcon}</Hidden>} */}
      {(navbarType === NavbarTypeEnum.SIDE_MENU ||
        navbarType === NavbarTypeEnum.MINI_SIDE_MENU) && (
        <Hidden smDown>{ButtonIcon}</Hidden>
      )}
      {/* visible in mobile device */}
      <Hidden mdUp>{ButtonIcon}</Hidden>
    </React.Fragment>
  );
});

const ButtonsGroup = withPermissions(() => {
  // const roles = AuthSelectors.useSelectUserRoles();
  const isLogin = AuthSelectors.useLogin();
  const permissions = AuthSelectors.usePermissions();
  const hostDetails = useHostDetails();
  const config = getNavbarConfig(
    isLogin === true,
    permissions,
    hostDetails.data?.settings ?? null
  );
  const classes = useStyles({});
  const history = useHistory();

  return (
    <Box className={classes.sectionDesktop}>
      {config.map(({ title, subItems, Icon, path, id }) => (
        <SelectButton
          key={id}
          buttonProps={{
            style: {
              marginRight: 15,
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontFamily: 'Roboto',
              lineHeight: '140.2%',
              textTransform: 'capitalize',
            },
            variant: 'text',
          }}
          action={() => path && history.push(path)}
          children={<TextWrapper Iconstart={Icon} text={title} path={path} />}
          items={(subItems || []).map(({ title, path }, index) => ({
            id: index.toString(),
            action: () => history.push(path),
            children: <TextWrapper key={index} text={title} path={path} />,
          }))}
        />
      ))}
    </Box>
  );
}, PermissionsEnum.NavigationAdministrationMenu);

interface ITextWrapperProps {
  text: any;
  Iconstart?: React.FC | undefined;
  IconEnd?: React.FC | undefined;
  path: string | null | undefined;
}

const TextWrapper = React.memo((props: ITextWrapperProps) => {
  const classes = useStyles({});
  const location = useLocation();
  const currentPath = location.pathname;
  const isSelected = props.path
    ? Paths.pathsIsTheSame(currentPath, props.path)
    : false;
  let textWrapperClasses = clsx({
    [classes.menuItemSelected]: isSelected,
  });
  return (
    <Box
      className={textWrapperClasses}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {props.Iconstart && <props.Iconstart />}
      <span className={classes.buttonText}>{props.text}</span>
      {props.IconEnd && <props.IconEnd />}
    </Box>
  );
});

interface ElevationScrollProps {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: React.ReactElement;
  propsOnScroll: any;
}

function ElevationScroll(props: ElevationScrollProps) {
  const { children, window, propsOnScroll } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, trigger && propsOnScroll);
}

export default AppbarMenu;
